<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="31.229" height="31.229" viewBox="0 0 31.229 31.229">
    <path id="clock-regular" d="M23.615,8A15.615,15.615,0,1,0,39.229,23.615,15.612,15.612,0,0,0,23.615,8Zm0,28.207a12.592,12.592,0,0,1,0-25.185,12.73,12.73,0,0,1,8.905,3.687,12.38,12.38,0,0,1,3.687,8.905A12.589,12.589,0,0,1,23.615,36.207Zm3.891-6.573L22.16,25.749a.76.76,0,0,1-.309-.611V14.8a.758.758,0,0,1,.756-.756h2.015a.758.758,0,0,1,.756.756v8.922l4.206,3.06a.755.755,0,0,1,.164,1.058L28.563,29.47A.761.761,0,0,1,27.506,29.634Z" transform="translate(-8 -8)" fill="#fff"/>
  </svg>
</template>

<script>
  export default {
    name: 'IconClocks',
  }
</script>
